export default __webpack_public_path__ + "static/media/link-help.d35b8c1a.png";